module.exports = __webpack_public_path__ + "static/media/tt_commons_demibold-webfont.f522ab40.woff";